import useGetMe from '@/api/queries/me/useGetMe';
import { setPlausibleProperties } from '@payaca/shared-web/analytics/plausible';
import { useLayoutEffect } from 'react';

export const usePlausibleProperties = () => {
  const { user } = useGetMe();

  const accountId = user?.account.id;
  const userRole = user?.systemRole;
  const accountProductName = user?.account.activeSubscription?.tier;

  useLayoutEffect(() => {
    setPlausibleProperties({ accountId, userRole, accountProductName });
    return () => setPlausibleProperties({});
  }, [accountId, userRole, accountProductName]);
};
